import { usePoliciesList } from "data/ss-data-hooks";
import SettingsPanelLayout from "pages/settings/common/settings-panel-layout";
import OffersItem from "pages/settings/offers/offers-item";

const Offers = () => {
  const { data } = usePoliciesList();

  const policyItems =
    data?.map((p) => {
      const policy = {
        ...p,
        policyId: p.platformPolicyId,
        insightPolicyId: p.keystonePolicyId,
      };
      return <OffersItem key={policy.policyId} policy={policy} />;
    }) ?? [];

  return (
    <SettingsPanelLayout title="Property services" policyItems={policyItems} />
  );
};

export default Offers;
